import { FeatureCollection, MultiPolygon } from "geojson";
import { OnDemandRxType, RxType } from "./enums";
import { Enrollment } from "./field";

export type Rx = {
    id: number;
    field: number;
    irrigation_system: number;
    name: string;
    imagery: number;
    table: FeatureCollection<MultiPolygon>;
    total_application_time: number;
    total_fertilizer: number;
    depth_inches: number;
    injection_rate_gal_per_hour: number;
    rx_type: RxType;
    fertilizer_product: number;
    speed_percentage: number;
    max_speed_percentage: number;
    target_rate_attribute: string;
    target_rate_units: TargetRateUnits;
    status: number;
    template_type: "management_layer" | "data_layer" | "imagery";
    template_id: number;
    plots: FeatureCollection<MultiPolygon>;
    average_n_rate: number;
};

export type ListRx = {
    id: number;
    name: string;
    field: {
        id: number;
        name: string;
    };
    imagery?: number;
    total_application_time?: number;
    total_fertilizer?: number;
    depth_inches?: number;
    injection_rate_gal_per_hour?: number;
    rx_type: RxType;
    fertilizer_product: string;
    speed_percentage?: number;
    max_speed_percentage?: number;
    created_date: string;
    status: number;
    plot_ids?: number[];
};

export enum TargetRateUnits {
    PoundsNPerAcre = 1,
    GallonsPerAcre = 2,
    PoundsPerAcre = 3,
}

export enum OptimalApproach {
    N_UPTAKE_4_PERC_THRESHOLD = "N_UPTAKE_4_PERC_THRESHOLD",
    N_UPTAKE_3_PERC_THRESHOLD = "N_UPTAKE_3_PERC_THRESHOLD",
    N_UPTAKE_2_PERC_THRESHOLD = "N_UPTAKE_2_PERC_THRESHOLD",
    OPTIMAL_PROFIT = "OPTIMAL_PROFIT",
    IMAGERY_ONLY = "IMAGERY_ONLY",
}

export type PrecomputedRx = {
    id: number;
    created_date: string;
    field: number;
    on_demand_type: OnDemandRxType;
    technique: string;
    target_rate_n: number;
    rx: number;
    imagery: number;
    optimal_approach: OptimalApproach;
    planting_date?: string;
    n_applied_lbs?: number;
    irrigation_amount_inches?: number;
};

export type FieldWithPrecomputedRx = {
    id: number;
    name: string;
    precomputed_rxs: PrecomputedRx[];
    farm: {
        id: number;
        name: string;
        group_type: string;
    };
    service_provider: {
        id: number;
        name: string;
        group_type: string;
        account_manager: {
            id: number;
            username: string;
            full_name: string;
        };
    };
    default_product: {
        id: number;
        name: string;
        fertilizer_type: number;
        density: number;
        percent_N: string;
        lbs_N_per_gallon: number;
        created_by: number;
        last_modified_by: number;
    };
    active_enrollment: Enrollment;
};

export type GenerateRxResponse = {
    prescription_id: number;
};
